// extracted by mini-css-extract-plugin
export default {"spinner":"spinnerFullUI_spinner__yw8wU","withNavigation":"spinnerFullUI_withNavigation__XiZ4T"};